import { message, User } from './../../shared/services/user';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {
  ready = false;
  users = [];
  userProfile: User;
  user;
  chat: Observable<any>;
  chatThread = [];
  recipient;

  message: message = {
    message: "",
    from: "",
    to: "",
    seen: false,
    date: new Date(),
  };
  autoComplete = {
    displayName: {},
    email: {},
  };
  autoCompleteKeys = {
    displayName: {},
    email: {},
  };
  usersProfile: {}
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = [];
  thread: string;
  constructor(public authService: AuthService, private db: AngularFirestore,) { }
  setUser() {
    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    // this.LedgerEntry.user = this.userProfile.displayName;
    // this.LedgerEntry.userEmail = this.userProfile.email;
    // this.LedgerEntry.userNumber = this.userProfile.number;
    // this.LedgerEntry.userId = this.user.uid;
  }

  ngOnInit() {
    this.setUser();
    this.getUsers();
  }
  getUsers() {

    this.db.collection("users").get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.users = [];
        this.usersProfile = {};
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as User;
          const id = doc.id;
          this.users.push({ id, data });
          this.usersProfile[id] = data;
          this.addAutoComplete(data);
          this.ready = true;

        });
      });
  }
  addAutoComplete(data) {
    var me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];
      if (me.autoComplete[key][data[key]] != "" && data[key] != "") {
        me.autoComplete[key][data[key]] = "";
        me.autoCompleteArray.push(data[key]);

      }

    });
    me.autoCompleteString = JSON.stringify(me.autoComplete);
    //console.log(this.autoComplete);
  }
  public itemsCollection = null;
  startChat(user) {
    this.recipient = user;
    
    this.thread = this.authService.startChat(this.userProfile, user.data);
    console.log(this.thread);
    
    this.message.message = "";
    this.message.from = this.userProfile.uid;
    this.message.to = user.data.uid;
    this.chatThread = [];
    this.userProfile.unreadMessages
    for (var i = 0; i < this.userProfile.unreadMessages.length; i++) {

      if (this.userProfile.unreadMessages[i] === user.id) {

        this.userProfile.unreadMessages.splice(i, 1);
      }

    }
    const receivingUserRef: AngularFirestoreDocument<any> = this.db.doc(`users/${this.message.from}`);
    // this.chatThread.push(JSON.parse(JSON.stringify(this.message)));
    // !this.usersProfile[this.message.to].unreadMessages.includes(this.message.from) ? this.usersProfile[this.message.to].unreadMessages.push(this.message.from) : null;
    receivingUserRef.set(this.userProfile, {
      merge: true
    })
    this.itemsCollection = this.db.collection('messages');
    return this.itemsCollection
      .doc(this.thread)
      .valueChanges()
      .subscribe(item => {
        console.log(item);
        this.chatThread = item.chat;
        return item;
        // If you prefer including itemId back to object
        // return {...item, id: docId}
      });
  //   this.db.doc(`messages/${this.thread}`).ref.get().then(function (doc) {
  //     if (doc.exists) {
  //       this.chatThread = [];
  //       debugger
  //       var r = doc.data();
  //       this.chatThread = r['chat'];
  //       return r;
  //     } else {
  //       console.log("There is no document!");
  //     }
  //   }).catch(function (error) {
  //     console.log("There was an error getting your document:", error);
  //   });
  // }
  // .snapshotChanges().pipe(map(actions => {
  //     this.chatThread = [];
  //     debugger
  //     var r = actions.payload.data();
  //     this.chatThread = r['chat'];
  //     return r;
  //     //   .map(a => {
      //   //Get document data
      //   const data = a.payload.doc.data();
      //   const id = a.payload.doc.id;
        
      //   id==this.thread?
      //   this.chatThread = data['chat']:null;
      //   return { data };
      // });
    // }));
    
   }
  sendMessage() {
// this.recipient
    
    this.getUsers();
    this.message.date = new Date();
    const userRef: AngularFirestoreDocument<any> = this.db.doc(`messages/${this.thread}`);
    this.chatThread.push(JSON.parse(JSON.stringify(this.message)));
    userRef.set({chat:this.chatThread}, {
      merge: true
    })
    const receivingUserRef: AngularFirestoreDocument<any> = this.db.doc(`users/${this.message.to}`);
    // this.chatThread.push(JSON.parse(JSON.stringify(this.message)));
    !this.usersProfile[this.message.to].unreadMessages.includes(this.message.from) ? this.usersProfile[this.message.to].unreadMessages.push(this.message.from): null;
    receivingUserRef.set(this.usersProfile[this.message.to], {
      merge: true
    })
    this.message.message = "";
    // this.message.date = new Date();
   }
  //TODO messenger
}
